import React, { useContext, useEffect, useRef, useState } from 'react'

import { Card, Form, Input, Select, Typography } from 'antd';
import { BellOutlined} from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';

import DiMarketingNotificationTour from '../../../../tours/DiMarketingNotificationTour';
import MarketingOperationCopyButton from '../../MarketingOperationCopyButton';
import { CreateOperationDataContext } from '../../../../../helpers/Context';
import MarketingOperationShortcode from '../../MarketingOperationShortcode';
import { apiGetAllAppPages } from '../../../../../helpers/Api';

export default function ChannelPushNotificationForm() {
   
  const [text, setText] = useState(''); // Stato per il contenuto della TextArea

  const [appPages, setAppPages] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const { onInputFocus, channelsGroupObjLabel, globalContext } = useContext(CreateOperationDataContext);
  const { errorNotification, appToken, diAppRef } = globalContext; 
  
  const formPrefix = "PUSH";

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 }, 
      md: { span: 10 },
      lg: { span: 12 },
      xl: { span: 8 },
      xxl: { span:6 },
    },
  };
  const formItemOrientation = "horizontal";

  

    /////////////////////////////////////////////////////////////////////////////////////////// 
            //////////////////// recupero le pagine app easyappear ///////////////
   ///////////////////////////////////////////////////////////////////////////////////////////

  
  useEffect(() => {
    if (!appToken) return;

    const fetchAppPages = async () => {
      try {
        setLoading(true);
        const res = await apiGetAllAppPages(appToken);

        if (!res.message) {
          setAppPages(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.error(error);
        errorNotification(error);
      } finally {
        setLoading(false);
      }
    };

    fetchAppPages();
}, [appToken]);


  return (
    <Card className='bg-dark-02' ref={diAppRef.refOperationsNotificationArea}>
      
      <div className='w-100 mb-10 text-right'>
        <DiMarketingNotificationTour context={globalContext}/>
      </div>

      <MarketingOperationShortcode/>

      <Typography className="fs-16 bold mb-10">
        <BellOutlined /> Dati per la Notifica Push
      </Typography>

      <div ref={diAppRef.refOperationsNotificationTitle}>
        <Form.Item
          {...formItemLayout} 
          layout={formItemOrientation}
          name={[channelsGroupObjLabel,formPrefix, "title"]}
          label={
            <div className="flex gap-5">
              <MarketingOperationCopyButton
                fieldName={[channelsGroupObjLabel, formPrefix, "title"]}
              />
              Titolo
            </div>
          }
          rules={[
            {
              required: true,
              message: "Per favore, inserisci il titolo della notifica!",
            },
          ]}
        >
          <Input
            onFocus={()=>onInputFocus(diAppRef.refOperationsNotificationTitle, [channelsGroupObjLabel, formPrefix, "title"])}
            maxLength={50}
            showCount
            allowClear
          />
        </Form.Item>
      </div>

     <div ref={diAppRef.refOperationsNotificationDescription}>
        <Form.Item
          {...formItemLayout} 
          layout={formItemOrientation}
          name={[channelsGroupObjLabel, formPrefix, "message"]}
          label={
            <div className="flex gap-5">
              <MarketingOperationCopyButton
                fieldName={[channelsGroupObjLabel ,formPrefix, "message"]}
              />
              Descrizione
            </div>
          }
          rules={[
            {
              required: true,
              message: "Per favore, inserisci il testo della notifica!",
            },
          ]}
        >
          <TextArea
              onFocus={()=>onInputFocus(diAppRef.refOperationsNotificationDescription, [channelsGroupObjLabel, formPrefix, "description"])}
              maxLength={300}
              value={text}
              showCount
              allowClear
           />
        </Form.Item>
     </div>

      <div ref={diAppRef.refOperationsNotificationAction}>
        <Form.Item
          {...formItemLayout} 
          layout={formItemOrientation}
          label={"Pagina di Atterraggio"}
          name={[channelsGroupObjLabel,formPrefix, "page_id"]}
          key={[channelsGroupObjLabel, formPrefix, "page_id"]}
        >
          <Select
            loading={loading}
            placeholder="Seleziona la pagina di atterraggio"
            className="w-100 min-w-150"
            allowClear
            options={appPages}
          />
        </Form.Item>
      </div>

    </Card>
  );
}
